import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import './Map.css';
import config from '../../dashboard_config.json';
import MapMarker from '../MapMarker/MapMarker';
import MapCard from '../MapCard/MapCard';
// import { fitBounds } from 'google-map-react/utils';

const GOOGLE_API_KEY = config.dashboard.apiKeys.google.googleApiKey;
const enableDarkModeMap = config.dashboard.map.enableDarkModeMap;

class Map extends React.PureComponent {
	state = {
		mapCenter: {
			lat: 0,
			lng: 0
		},
		mapZoom: 14,
		expandedClusterKey: null
	};

	markerIcon = './images/green_light_mini.png';
	markerIconBroadcasting = './images/red_light_mini.png';

	_iconScheduler;

	componentDidMount() {
		if ('geolocation' in navigator) {
			navigator.geolocation.getCurrentPosition((position) => {
				const { latitude, longitude } = position.coords;
				const mapCenter = {
					lat: latitude,
					lng: longitude
				};
				this.setState({ mapCenter });
			});
		}

		// let index = 0;
		// this._iconScheduler = setInterval(() => {
		// 	index = index < 3 ? index + 1 : 0;
		// 	this.markerIconBroadcasting = `./images/omnistream_icon_${index}.png`;

		// 	// if ('geolocation' in navigator) {
		// 	// 	navigator.geolocation.getCurrentPosition((position) => {
		// 	// 		const { latitude, longitude } = position.coords;
		// 	// 		const mapCenter = {
		// 	// 			lat: latitude,
		// 	// 			lng: longitude
		// 	// 		};
		// 	// 		// if (mapCenter.lat !== this.state.mapCenter.lat || mapCenter.lng !== this.state.mapCenter.lng){
		// 	// 			this.setState({ mapCenter });
		// 	// 		// }
		// 	// 	});
		// 	// }
		// }, 3000);
	}

	componentWillUnmount() {
		clearInterval(this._iconScheduler);
	}

	handleShowAllPrimaries = () => {
		const loggedInPrimaryUsers = this.props.primaryUsers.filter(
			(primary) => primary.isActive
		);

		if (loggedInPrimaryUsers.length === 1) {
			this.handleLocatePrimary(
				loggedInPrimaryUsers[0].latitude,
				loggedInPrimaryUsers[0].longitude
			);

			return;
		}

		let points = [];
		loggedInPrimaryUsers.forEach((primary) => {
			points.push({
				lat: primary.latitude,
				lng: primary.longitude
			});
		});

		// For some reason LatLngBounds() return object with weird properties names,
		// thus the temporary variable name
		const boundsWithWeirdPropertiesNames = new window.google.maps
			.LatLngBounds();

		for (let i = 0; i < points.length; i++) {
			boundsWithWeirdPropertiesNames.extend(points[i]);
		}
		// Due to the above weirdness next code block translates
		// the weird names to normal so fitBounds() will work
		const bounds = {
			nw: {
				lat: boundsWithWeirdPropertiesNames.Ya.i,
				lng: boundsWithWeirdPropertiesNames.Ua.i
			},
			se: {
				lat: boundsWithWeirdPropertiesNames.Ya.j,
				lng: boundsWithWeirdPropertiesNames.Ua.j
			}
		};

		const size = {
			width: Math.max(
				document.documentElement.clientWidth,
				window.innerWidth || 0
			),
			height: Math.max(
				document.documentElement.clientHeight,
				window.innerHeight || 0
			)
		};

		// const { center, zoom } = fitBounds(bounds, size);

		// this.setState({
		// 	mapCenter: center,
		// 	mapZoom: zoom
		// });
	};

	handleLocatePrimary = (lat, lng) => {
		const mapCenter = { lat, lng };
		this.setState({
			mapCenter,
			// mapZoom: 19
		});
	};

	onPositionChanged = (changeEventValue) => {
		console.log(changeEventValue)
		const mapCenter = changeEventValue.mapCenter;
		this.setState({
			mapCenter,
			// mapZoom: 19
		});
	}
	toggleExpandedCluster = (clusterKey) => {
		this.setState(prevState => ({
			expandedClusterKey: prevState.expandedClusterKey === clusterKey ? null : clusterKey
		}));
	};

	getGroupedMarkers = (primaries) => {
		const clusters = {};
		const sorted = [...primaries].sort((a, b) => a.id - b.id);

		// 1. Group by approximate location (~11m window)
		sorted.forEach(p => {
			const lat = parseFloat(p.latitude);
			const lng = parseFloat(p.longitude);
			if (isNaN(lat) || isNaN(lng)) return;
			const key = `${lat.toFixed(4)},${lng.toFixed(4)}`;
			if (!clusters[key]) clusters[key] = [];
			clusters[key].push(p);
		});

		const finalMarkers = [];
		const { expandedClusterKey } = this.state;

		Object.keys(clusters).forEach(key => {
			const clusterUnits = clusters[key];
			const [baseLat, baseLng] = key.split(',').map(parseFloat);

			if (clusterUnits.length > 1) {
				if (expandedClusterKey === key) {
					// Show all units in the stack
					clusterUnits.forEach((p, index) => {
						finalMarkers.push({
							...p,
							latitude: baseLat,
							longitude: baseLng,
							stackIndex: index,
							// Clicking the top/original marker collapses the group
							onClick: () => this.toggleExpandedCluster(key)
						});
					});
				} else {
					// Show one cluster marker with joined names (truncate if > 3)
					const isAnyBroadcasting = clusterUnits.some(u => u.isBroadcasting);
					const namesToDisplay = clusterUnits.map(u => u.displayedName || u.username);

					let combinedNames = '';
					if (namesToDisplay.length > 3) {
						combinedNames = namesToDisplay.slice(0, 3).join(' | ') + '...';
					} else {
						combinedNames = namesToDisplay.join(' | ');
					}

					finalMarkers.push({
						id: `cluster-${key}`,
						latitude: baseLat,
						longitude: baseLng,
						isBroadcasting: isAnyBroadcasting,
						displayedName: combinedNames,
						username: combinedNames,
						unitsCount: clusterUnits.length,
						stackIndex: 0,
						onClick: () => this.toggleExpandedCluster(key)
					});
				}
			} else {
				// Single unit
				finalMarkers.push({
					...clusterUnits[0],
					latitude: baseLat,
					longitude: baseLng,
					stackIndex: 0
				});
			}
		});

		return finalMarkers;
	};

	render() {
		const {
			primaryUsers,
			primariesBroadcastDetails,
			focusedPrimaryId,
			isChangingStartStopInProgress,
			screenSize,
			handlePrimaryFocus,
			clickStartStop,
			clickIFBmouseDown,

		} = this.props;

		const activePrimaryUsers = primaryUsers.filter(
			(primaryUser) => primaryUser.isActive
		);

		const displayMarkers = this.getGroupedMarkers(activePrimaryUsers);

		const sortedPrimaryUsers = primaryUsers.sort(
			(obj1, obj2) => obj1.id - obj2.id
		);

		return (
			<div className="map">
				<div id="map-container">
					<GoogleMapReact
						bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
						center={this.state.mapCenter}
						zoom={this.state.mapZoom}
						onChange={this.onPositionChanged}
						options={enableDarkModeMap ? {
							styles: [
								{ "elementType": "geometry", "stylers": [{ "color": "#212121" }] },
								{ "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
								{ "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
								{ "elementType": "labels.text.stroke", "stylers": [{ "color": "#212121" }] },
								{ "featureType": "administrative", "elementType": "geometry", "stylers": [{ "color": "#757575" }] },
								{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#000000" }] },
								{ "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "color": "#2c2c2c" }] }
							],
							disableDefaultUI: true,
							draggable: true,
							zoomControl: false,
							scrollwheel: true,
							disableDoubleClickZoom: true
						} : {}}
					>
						{displayMarkers.map(
							({
								id,
								latitude,
								longitude,
								isBroadcasting,
								displayedName,
								username,
								stackIndex,
								unitsCount,
								onClick
							}) => (
								<MapMarker
									key={id}
									lat={latitude}
									lng={longitude}
									stackIndex={stackIndex}
									unitsCount={unitsCount}
									onClick={onClick}
									imgSrc={
										isBroadcasting ? (
											this.markerIconBroadcasting
										) : (
											this.markerIcon
										)
									}
									primaryName={
										displayedName ? displayedName : username
									}
								/>
							)
						)}
					</GoogleMapReact>
				</div>
				<div className="map-cards-section">

					<div id="map-accordion">
						{sortedPrimaryUsers.map(
							({
								id,
								displayedName,
								username,
								isActive,
								isBroadcasting,
								latitude,
								longitude
							}) => {
								const broadcastDetails = primariesBroadcastDetails.find(
									(detail) => detail.primaryId === id
								);
								const bitrate = broadcastDetails ? broadcastDetails.bitrate : '0.00';
								const duration = broadcastDetails ? broadcastDetails.duration : '00:00';

								// Extract primary device info
								const usersDevices = this.props.devicesSetsInfo[id] || [];
								const primaryDevice = usersDevices.find(d => d.isPrimary) || {};

								return (
									<MapCard
										key={id}
										primaryId={id}
										primaryName={
											displayedName ? displayedName : username
										}
										isActive={isActive}
										isBroadcasting={isBroadcasting}
										bitrate={bitrate}
										duration={duration}
										batteryLevel={primaryDevice.batteryLevel}
										isCharging={primaryDevice.isCharging}
										batteryTemperature={primaryDevice.batteryTemperature}
										devices={usersDevices}
										focusedPrimaryId={focusedPrimaryId}
										isChangingStartStopInProgress={isChangingStartStopInProgress}
										screenSize={screenSize}
										handlePrimaryFocus={handlePrimaryFocus}
										clickStartStop={clickStartStop}
										clickIFBmouseDown={clickIFBmouseDown}

										locatePrimary={() =>
											this.handleLocatePrimary(latitude, longitude)}
									/>
								);
							}
						)}
					</div>
				</div>
			</div>
		);
	}
}

Map.propTypes = {
	primaryUsers: PropTypes.array.isRequired,
	primariesBroadcastDetails: PropTypes.array.isRequired,
	devicesSetsInfo: PropTypes.object.isRequired,
	handlePrimaryFocus: PropTypes.func.isRequired,
	clickStartStop: PropTypes.func.isRequired,
	clickIFBmouseDown: PropTypes.func.isRequired,
	screenSize: PropTypes.string.isRequired
};

export default Map;
